module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hot-container"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "src": "https://assets.aiyaopai.com/Group%204@3x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "back-home",
    attrs: {
      "to": {
        name: 'liveDetail',
        params: {
          liveId: _vm.live.Id
        }
      }
    }
  }, [_vm._v("主页")]), _vm._v(" "), _c('section', {
    staticClass: "hot-view"
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.shot(item)
        }
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.Url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.Title))])])
  }), _vm._v(" "), _c('shot', {
    ref: "shot",
    attrs: {
      "url": _vm.url
    }
  }, [_c('div', {
    staticClass: "item-print"
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://assets.aiyaopai.com/Group%204@3x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "wrap2"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.print.Url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.print.Title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.live.Title))]), _vm._v(" "), _c('div', {
    staticClass: "qr"
  }, [_c('qrcode', {
    ref: "qrcode",
    attrs: {
      "size": 100,
      "value": _vm.url,
      "type": "img"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("长按识别二维码")]), _vm._v(" "), _c('p', [_vm._v("获取更多精彩内容")])])])])])], 2), _vm._v(" "), _c('wechat-share', {
    ref: "wechat",
    attrs: {
      "title": '精彩看点 | ' + _vm.live.Title,
      "subTitle": _vm.live.SubTitle,
      "shareImg": _vm.live.ShareLogo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c15325a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/live/HotView.vue
// module id = 527
// module chunks = 1